import { render, staticRenderFns } from "./ContactIcons.vue?vue&type=template&id=25c2a180"
import script from "./ContactIcons.vue?vue&type=script&lang=js"
export * from "./ContactIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports